var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { ModelManager, getSafeStorage, getStatsigClient, getCartItemsIdsString, getOrCreateStatsigManager, buildModelRequestPayload, shouldSendPayload, Logger, syncDebugFlag, } from './statsig-manager.js';
const OLD_MODEL_KEY = "dyo_test_pdp_features";
const MODEL_KEY = "statsig:test:dyo:pdpfeatures";
const EXPERIMENT = {
    title: "DyoPdpFeatures",
    name: "dyo-pdp-features-v0",
    gate: "dyo-pdp-features",
    layer: "dyo-pdp-features",
};
const DEBUG = false; // Altere para false para desativar logs deste teste
if (!customElements.get("dyo-pdp-features"))
    customElements.define("dyo-pdp-features", class DyoPDPFeatures extends HTMLElement {
        constructor() {
            super();
            this.customerId = this.getAttribute("data-customer-id") || null;
            this.statsigGate = this.getAttribute("data-statsig-gate") || EXPERIMENT.gate;
            this.statsigLayer = this.getAttribute("data-statsig-layer") || EXPERIMENT.layer;
            this.statsigStableId = null;
            this.allocatedExperiment = EXPERIMENT.name;
            this.modelUrl = null;
            this.REQUEST_TIMEOUT_MS = 10000;
            this.modelManager = new ModelManager();
            this.objExperimentInfos = {
                stable_id: this.statsigStableId,
                gate: this.statsigGate,
                layer: this.statsigLayer,
                cart: getCartItemsIdsString(),
                customer_id: this.customerId,
                allocated_experiment: this.allocatedExperiment,
                category: "Statsig",
                component: `${EXPERIMENT.name}`,
            };
        }
        connectedCallback() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    syncDebugFlag(EXPERIMENT.name, DEBUG);
                    const migrated = this.migrateLegacyModelIfNeeded();
                    yield getOrCreateStatsigManager();
                    this.runTest(migrated);
                }
                catch (error) {
                    Logger.error(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] StatsigManager not ready`, error, this.objExperimentInfos);
                }
            });
        }
        // Função principal que executa o fluxo do experimento
        runTest(migrated) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Executando runTest(): `, EXPERIMENT);
                try {
                    const stableContext = yield ((_a = getStatsigClient()) === null || _a === void 0 ? void 0 : _a.getAsyncContext());
                    this.statsigStableId = (_b = stableContext === null || stableContext === void 0 ? void 0 : stableContext.stableID) !== null && _b !== void 0 ? _b : null;
                    const persistedModelData = this.loadModelFromStorage();
                    if (persistedModelData) {
                        Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Reusing persisted group data: `, persistedModelData);
                        this.applyLayoutChanges(persistedModelData.product_description);
                    }
                    const experimentManager = yield getOrCreateStatsigManager();
                    const gateOpen = yield experimentManager.checkGate(this.statsigGate);
                    const shouldPersist = gateOpen || migrated;
                    if (!shouldPersist) {
                        Logger.warn(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Gate closed and no migration. Exiting without persisting.`, this.objExperimentInfos);
                        return;
                    }
                    const triggers = ["first_load", "stable_id"];
                    const shouldSend = shouldSendPayload(triggers, MODEL_KEY, "every");
                    if (!shouldSend) {
                        Logger.warn(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Not available to send payload. Aborting...`, triggers, this.objExperimentInfos);
                        return;
                    }
                    const layer = yield experimentManager.getLayerParams(this.statsigLayer);
                    if (!layer) {
                        Logger.warn(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Layer not found. Exiting.`, this.objExperimentInfos);
                        return;
                    }
                    this.modelUrl = layer.get("modelUrl");
                    if (!this.modelUrl) {
                        Logger.error(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] No model URL found.`, this.objExperimentInfos);
                        return;
                    }
                    const includeFields = [
                        "customer_id",
                        "stable_id",
                        "allocated_experiment",
                        "cart",
                        "utms",
                        "products",
                        "collections"
                    ];
                    const payload = buildModelRequestPayload({
                        customer_id: (_c = this.customerId) !== null && _c !== void 0 ? _c : null,
                        stable_id: (_d = this.statsigStableId) !== null && _d !== void 0 ? _d : undefined,
                        allocated_experiment: this.allocatedExperiment,
                    }, includeFields);
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Payload to request: `, payload);
                    const modelData = yield this.modelManager.getModel(this.modelUrl, payload, { timeout: this.REQUEST_TIMEOUT_MS }, MODEL_KEY, includeFields);
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Applying layout using new data received from model group at first time:`, modelData);
                    this.applyLayoutChanges(modelData === null || modelData === void 0 ? void 0 : modelData.product_description);
                }
                catch (error) {
                    Logger.error(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Error in runTest()`, error, this.objExperimentInfos);
                }
            });
        }
        // Aplica as alterações no layout da página de acordo com a descrição do produto retornada pelo modelo
        applyLayoutChanges(productDescription) {
            var _a, _b, _c;
            // Aplica somente na página de produto, exceto kits
            if (window.location.href.includes("/products/") && !window.location.href.includes("kit")) {
                // Caso padrão, não altera nada
                if (productDescription === "default") {
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Default product description`);
                    return;
                }
                // Seleciona todos os elementos de acordeon do produto
                const accordions = Array.from((_a = document.getElementsByClassName("product__accordion")) !== null && _a !== void 0 ? _a : []);
                if (accordions.length < 4)
                    return;
                // Exibe todos os acordeons
                accordions.forEach((accordion) => {
                    if (accordion instanceof HTMLElement) {
                        accordion.style.display = "block";
                    }
                });
                // Esconde elementos específicos para preparar o layout customizado
                const title = document.querySelector(".product-features h3");
                const glide = document.querySelector(".product-features glide-component");
                const description = document.querySelector(".product__description");
                if (title instanceof HTMLElement)
                    title.style.display = "none";
                if (glide instanceof HTMLElement)
                    glide.style.display = "none";
                if (description instanceof HTMLElement)
                    description.style.display = "none";
                // Controla o estado dos acordeons conforme a descrição do produto
                if (productDescription === "accordion_opened") {
                    (_b = document.getElementsByClassName("product__accordion")[0].querySelector("details")) === null || _b === void 0 ? void 0 : _b.setAttribute("open", "true");
                    (_c = document.getElementsByClassName("product__accordion")[1].querySelector("details")) === null || _c === void 0 ? void 0 : _c.setAttribute("open", "true");
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Accordion opened`);
                }
                else if (productDescription === "accordion_closed") {
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Accordion closed`);
                }
            }
        }
        // Função para migrar dados do modelo legado para o novo formato
        migrateLegacyModelIfNeeded() {
            try {
                const storage = getSafeStorage();
                const legacyData = storage.getItem(OLD_MODEL_KEY);
                const parsedLegacy = legacyData ? JSON.parse(legacyData) : null;
                if (parsedLegacy && !storage.getItem(MODEL_KEY)) {
                    storage.setItem(MODEL_KEY, JSON.stringify(parsedLegacy));
                    const stableId = storage.getItem("STATSIG_LOCAL_STORAGE_STABLE_ID");
                    if (stableId) {
                        storage.setItem(`${MODEL_KEY}:stableid`, stableId);
                    }
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Legacy model data migrated from ${OLD_MODEL_KEY} to ${MODEL_KEY}`);
                    return true;
                }
                if (legacyData && storage.getItem(MODEL_KEY)) {
                    Logger.log(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Possible rollback detected: ${OLD_MODEL_KEY} still exists`);
                }
            }
            catch (error) {
                Logger.error(EXPERIMENT.name, `[Statsig][${EXPERIMENT.name}] Failed to migrate legacy model data`, error, this.objExperimentInfos);
            }
            return false;
        }
        // Carrega os dados do modelo persistidos no localStorage, se existirem
        loadModelFromStorage() {
            const storage = getSafeStorage();
            let parsed = null;
            try {
                const raw = storage.getItem(MODEL_KEY);
                parsed = raw ? JSON.parse(raw) : null;
            }
            catch (_a) {
                parsed = null;
            }
            if (!parsed || typeof parsed !== "object") {
                return null;
            }
            return parsed;
        }
    });
